import React from 'react'
import { Statistic } from 'semantic-ui-react'

const DataStatistics = () => (
  <div>
    <Statistic.Group widths='four'>
      <Statistic label='Leagues' value='30+' />
      <Statistic label='Teams' value='600+' />
      <Statistic label='Players' value='17,000+' />
      <Statistic label='Player Attributes' value='40+' />
    </Statistic.Group>
  </div>
)

export default DataStatistics



// WEBPACK FOOTER //
// ./src/components/DataStatistics.js